import { IGroupInfo } from "@home-health-notify/domain";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import GroupsIcon from "@mui/icons-material/Groups";
import {
  formatRescheduleDateTime,
  formatVisitDate,
  useTranslation,
} from "hhn-commons";
import React from "react";
import { PatientHeaderDescription } from "../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import Lupa from "../tabs/info/common/Lupa";
import {
  DetailItemLabel,
  DetailItemValue,
  DetailItemWrapper,
  PatientGroupDetailItem,
  PatientGroupDetailsWrapper,
} from "./CareTimeline.style";
import { SvgIconProps } from "@mui/material";

function DetailItem({
  title,
  value,
  icon,
}: {
  title: string;
  value: React.ReactNode;
  icon: React.ReactNode;
}) {
  const clonedIcon =
    typeof icon === "string"
      ? icon
      : React.cloneElement(icon as React.ReactElement<SvgIconProps>, {
          color: "secondary",
        });
  return (
    <PatientGroupDetailItem>
      {clonedIcon}
      <DetailItemWrapper>
        <DetailItemLabel>{title}</DetailItemLabel>
        <DetailItemValue component="span">{value}</DetailItemValue>
      </DetailItemWrapper>
    </PatientGroupDetailItem>
  );
}

const PatientGroupDetails = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  return (
    <PatientGroupDetailsWrapper>
      <PatientHeaderDescription
        patientStatus={groupInfo.patientStatus}
        name={groupInfo.name}
        servicesToPatient={groupInfo.servicesToPatient}
        meta={groupInfo.meta}
      />
      <DetailItem
        title={tNs("careTimeline.groupCreated")}
        value={formatRescheduleDateTime(groupInfo.createdAt)}
        icon={<GroupsIcon />}
      />
      {groupInfo?.patientCareTime && (
        <DetailItem
          title={tNs("careTimeline.episode")}
          value={`${formatVisitDate(groupInfo.patientCareTime.startDate)} - ${formatVisitDate(groupInfo.patientCareTime.endDate)}`}
          icon={<CalendarIcon />}
        />
      )}
      {groupInfo.lupa && (
        <DetailItem
          title={tNs("careTimeline.lupaThreshold")}
          value={<Lupa groupInfo={groupInfo} />}
          icon={tNs("careTimeline.lupa")}
        />
      )}
    </PatientGroupDetailsWrapper>
  );
};

export default PatientGroupDetails;
